export default __webpack_public_path__ + "assets/04n.f6e6108e.svg";